import { z } from 'zod';

import { I18Namespaces } from '@dealstack/shared/lib/common/i18n/i18n.ts';
import { SecurityParticipationThresholdBasis } from '@dealstack/shared/lib/generated';
import { TranslateFunction } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.types';

export const SecurityParticipationThresholdShape = (
	tCapManage: TranslateFunction<I18Namespaces.CAP_MANAGE>
) =>
	z
		.object({
			residueParticipationThresholdBasis: z.nativeEnum(SecurityParticipationThresholdBasis),
			participationThresholdBasisTier: z.string().nullable().optional(),
		})
		.refine(
			(data) => {
				const basis = data.residueParticipationThresholdBasis;
				const tier = data.participationThresholdBasisTier;

				if (basis === SecurityParticipationThresholdBasis.TOTAL_PROCEEDS_WITHIN_TIER) {
					return !!tier;
				}

				return true;
			},
			{
				message: tCapManage('securities.validations.participationThreshold.basisTier'),
				path: ['participationThresholdBasisTier'],
			}
		);

export type SecurityParticipationThresholdFormDto = z.infer<
	ReturnType<typeof SecurityParticipationThresholdShape>
>;
